import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { ComputedProductStatus, ProductListFilter } from "@/graphql/codegen/graphql"
import { useGetSuppliers } from "@/hooks/useGetSuppliers"

interface SupplierFilterChipsProps {
  selectedSuppliers?: string[]
  onRemove: (key: keyof ProductListFilter, value: string | ComputedProductStatus) => void
}

const SupplierFilterChips: React.FC<SupplierFilterChipsProps> = ({ selectedSuppliers, onRemove }) => {
  const { suppliers } = useGetSuppliers({ companyIds: selectedSuppliers })

  const supplierNames = useMemo(
    () =>
      selectedSuppliers
        ?.map((id: string) => {
          return suppliers.find((supplier) => supplier.companyId === id)?.name ?? ""
        })
        .filter(Boolean) || [],
    [selectedSuppliers, suppliers]
  )

  return (
    <>
      {supplierNames.map((name, idx) => (
        <FilterChip
          key={`${name}-${idx}`}
          label={`Supplier: ${name}`}
          onDelete={() => onRemove("companyIds", selectedSuppliers![idx])}
        />
      ))}
    </>
  )
}

export default SupplierFilterChips
